export default function Divider() {
  return (
    <div className="hidden sm:block" aria-hidden="true">
      <div className="py-6" />
    </div>
  )
}
